import {commercialWebsocketCommands} from '../../constants/commercialWebsocketCommands';
import {
    COMMERCIAL_ATTACHMENTS_UPLOADING,
    COMMERCIAL_ATTACHMENTS_UPLOADING_ERROR
} from '../../actions/commercial/actionCommercialAttachment';
import {COMMERCIAL_TICKET_RESET} from '../../actions/commercial/actionCommercialTicket';

export const commercialAttachment = (state = {
    correlationId: null,
    isTicketAttachmentUploading: false,
    attachmentsForUpload: [],
}, action) => {
    switch (action.type) {
        case COMMERCIAL_TICKET_RESET: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        case commercialWebsocketCommands.COMMERCIAL_GENERATED_PRESIGNED_URLS: {
            const {attachments} = action.payload;
            return Object.assign({}, state, {
                attachmentsForUpload: Array.isArray(attachments) ? attachments : [],
            });
        }
        case COMMERCIAL_ATTACHMENTS_UPLOADING: {
            return Object.assign({}, state, {isTicketAttachmentUploading: true});
        }
        //att done + error
        case commercialWebsocketCommands.COMMERCIAL_ATTACHMENTS_SAVED_ERROR:
        case COMMERCIAL_ATTACHMENTS_UPLOADING_ERROR: {
            return Object.assign({}, state, {
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        case commercialWebsocketCommands.COMMERCIAL_ATTACHMENTS_SAVED: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId,
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        default:
            return state;
    }
};
